export default function pxToRem(sizeInPx) {
    return (sizeInPx / parseFloat(getComputedStyle(document.documentElement).fontSize));
}
